import {gql} from '@apollo/client';

export const CURRENT_USER_QUERY = gql`
  query CurrentUserQuery {
    me {
      username
      fullName
      phoneNumber
      appleMusicToken
      id
    }
  }
`;
